import shareNow from "./share-now/share-now";

const BigErrorMainCon = document.getElementById("BigErrorMainCon");
const BigErrorTitle = document.getElementById("BigErrorTitle");
const BigErrorBody = document.getElementById("BigErrorBody");
const BigErrorBtnAcept = document.getElementById("BigErrorBtnAcept");
const BigErrorBtnCancel = document.getElementById("BigErrorBtnCancel");

class bigError {
  constructor() {
    // this._events();
  }

  _open(
    title,
    body,
    buttonAceptText,
    buttonAceptAction,
    buttonCancelText,
    buttonCancelAction
  ) {
    return new Promise((resolve) => {
      if (!buttonCancelText) {
        BigErrorBtnCancel.style.display = "none";
      } else {
        BigErrorBtnCancel.style.display = "inline-block";
        BigErrorBtnCancel.textContent = buttonCancelText;
      }

      if (!buttonAceptText) {
        BigErrorBtnAcept.style.display = "none";
      } else {
        BigErrorBtnAcept.style.display = "inline-block";
        BigErrorBtnAcept.textContent = buttonAceptText;
      }

      BigErrorMainCon.style.display = "flex";
      BigErrorTitle.textContent = title;
      BigErrorBody.textContent = body;

      const onAccept = () => {
        this._close();
        resolve(true);
      };

      const onCancel = () => {
        this._close();
        resolve(false);
      };

      BigErrorBtnAcept.onclick = onAccept;
      BigErrorBtnCancel.onclick = onCancel;
    });
  }

  _close() {
    BigErrorMainCon.style.display = "none";
  }
}

export default new bigError();
